
import { contains, ofList } from "../fable_modules/fable-library-js.5.3.0/Set.js";
import { tryFind, exists, ofArray } from "../fable_modules/fable-library-js.5.3.0/List.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.5.3.0/Util.js";
import { Record, Union } from "../fable_modules/fable-library-js.5.3.0/Types.js";
import { record_type, string_type, union_type } from "../fable_modules/fable-library-js.5.3.0/Reflection.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.5.3.0/Result.js";

/**
 * Novu topic holding the active supporters of one challenge. Membership is
 * maintained from Pledge events by the Watchdog; supporter-facing workflows
 * trigger to this key instead of looping over pledges.
 * Novu topic keys allow only [a-zA-Z0-9_:-] (or an email), which a lowercase
 * Guid and colons satisfy.
 */
export function supportersTopicKey(challengeId) {
    return `challenge:${challengeId}:supporters`;
}

/**
 * One reminder run per pledge for the life of the payment window; also the cancel key.
 */
export function donationReminderTransactionId(pledgeId) {
    return `${"pledge.donation-reminder.supporter"}:${pledgeId}`;
}

export const canaryWorkflows = ofList(ofArray(["pledge.received.host", "challenge.daily-log.supporter"]), {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
});

export const allMvpWorkflows = ofArray(["challenge.start-reminder.host", "challenge.start-reminder.supporter", "challenge.completed.host", "challenge.completed.supporter", "challenge.midpoint-progress.supporter", "challenge.abandoned.supporter", "challenge.daily-log.supporter", "challenge.daily-log-reminder.host", "pledge.payment-confirmation.supporter", "pledge.received.host", "pledge.donation-link.supporter", "pledge.donation-reminder.supporter", "user.welcome"]);

/**
 * Who the preference is about, used to group toggles on the profile page.
 */
export class PreferenceAudience extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AsSupporter", "AsHost"];
    }
}

export function PreferenceAudience_$reflection() {
    return union_type("Shared.NotificationWorkflows.PreferenceAudience", [], PreferenceAudience, () => [[], []]);
}

/**
 * A workflow the user may switch off, with the label shown on the profile page.
 */
export class NotificationPreferenceDefinition extends Record {
    constructor(WorkflowId, Label, Audience) {
        super();
        this.WorkflowId = WorkflowId;
        this.Label = Label;
        this.Audience = Audience;
    }
}

export function NotificationPreferenceDefinition_$reflection() {
    return record_type("Shared.NotificationWorkflows.NotificationPreferenceDefinition", [], NotificationPreferenceDefinition, () => [["WorkflowId", string_type], ["Label", string_type], ["Audience", PreferenceAudience_$reflection()]]);
}

export const criticalWorkflows = ofList(ofArray(["user.welcome", "pledge.payment-confirmation.supporter", "pledge.donation-link.supporter", "challenge.abandoned.supporter"]), {
    Compare: (x, y) => (comparePrimitives(x, y) | 0),
});

export function isCritical(workflowId) {
    return contains(workflowId, criticalWorkflows);
}

export const preferenceControlledWorkflows = ofArray([new NotificationPreferenceDefinition("challenge.daily-log.supporter", "Daily updates from challenges I support", new PreferenceAudience(0, [])), new NotificationPreferenceDefinition("challenge.midpoint-progress.supporter", "Midpoint progress from challenges I support", new PreferenceAudience(0, [])), new NotificationPreferenceDefinition("challenge.start-reminder.supporter", "Start reminders for challenges I support", new PreferenceAudience(0, [])), new NotificationPreferenceDefinition("challenge.completed.supporter", "Completion updates from challenges I support", new PreferenceAudience(0, [])), new NotificationPreferenceDefinition("pledge.donation-reminder.supporter", "Donation reminders for my pledges", new PreferenceAudience(0, [])), new NotificationPreferenceDefinition("challenge.start-reminder.host", "Start reminders for my challenges", new PreferenceAudience(1, [])), new NotificationPreferenceDefinition("challenge.completed.host", "Completion summary for my challenges", new PreferenceAudience(1, [])), new NotificationPreferenceDefinition("pledge.received.host", "New pledges on my challenges", new PreferenceAudience(1, [])), new NotificationPreferenceDefinition("challenge.daily-log-reminder.host", "Reminders to post my daily log", new PreferenceAudience(1, []))]);

export function isPreferenceControlled(workflowId) {
    return exists((d) => (d.WorkflowId === workflowId), preferenceControlledWorkflows);
}

export function tryPreferenceDefinition(workflowId) {
    return tryFind((d) => (d.WorkflowId === workflowId), preferenceControlledWorkflows);
}

/**
 * A workflow ID the caller is allowed to read or write a preference for — a member of
 * `preferenceControlledWorkflows`. `create` is the single place that enforces this
 * whitelist; the preferences API and the unauthenticated unsubscribe endpoint both
 * delegate to it instead of reimplementing the membership check.
 */
export class PreferenceControlledWorkflowId extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["PreferenceControlledWorkflowId"];
    }
}

export function PreferenceControlledWorkflowId_$reflection() {
    return union_type("Shared.NotificationWorkflows.PreferenceControlledWorkflowId", [], PreferenceControlledWorkflowId, () => [[["Item", string_type]]]);
}

export function PreferenceControlledWorkflowIdModule_create(workflowId) {
    if (isPreferenceControlled(workflowId)) {
        return new FSharpResult$2(0, [new PreferenceControlledWorkflowId(workflowId)]);
    }
    else {
        return new FSharpResult$2(1, ["Unknown notification preference"]);
    }
}

export function PreferenceControlledWorkflowIdModule_value(_arg) {
    return _arg.fields[0];
}

//# sourceMappingURL=NotificationWorkflows.js.map
